import { decamelize } from 'helpers/camelize';
import {
  fetchWrapper,
  handleResponse,
  hcUrlV3,
  buildOpts,
  objectToQueryString,
  transformTwoStageMenuMealsResponse,
} from 'services/RequestService/helpers';

export const getMenu = async ({ params: { menuSlug } }) => {
  const response = await fetchWrapper(hcUrlV3(`/menus/${menuSlug}`), buildOpts());
  return handleResponse(response);
};

export const getMenuCategories = async ({ params }) => {
  const { menuSlug, mealPlanSlug, ...restParams } = params;
  const response = await fetchWrapper(
    hcUrlV3(
      `/menu_categories/${menuSlug}/${mealPlanSlug}?${objectToQueryString(decamelize(restParams, true))}`
    ),
    buildOpts({
      method: 'GET',
    })
  );
  return handleResponse(response);
};

export const getMenuMeals = async ({ params: { menuSlug, mealPlanSlug } }) => {
  const response = await fetchWrapper(
    hcUrlV3(`/menus/${menuSlug}/${mealPlanSlug}/meals`),
    buildOpts()
  );
  return handleResponse(response, transformTwoStageMenuMealsResponse);
};

export const getPreviouslyOrderedMenuMeals = async ({ params: { menuSlug, mealPlanSlug } }) => {
  const response = await fetchWrapper(
    hcUrlV3(`/menus/${menuSlug}/${mealPlanSlug}/previously_ordered_menu_meals`),
    buildOpts()
  );
  return handleResponse(response);
};
